<canvas>
  <ng-template #screenshotcontainer></ng-template>
</canvas>
